import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import getters from './store/getters'
import actions from './store/actions'
import mutations from './store/mutations'

Vue.use(Vuex)

const state = {
  sidebarShow: 'responsive',
  sidebarMinimize: false,
  quoteActiveTab: 0,
  cart: {
    productsCost: 0,
    IVACost: 0,
    consTax: 0,
    items: []
  },
  quote:{
    directorio: '',
    dependencia: '',
    orden_Compra: '',
    Dias_Validez: 0
  },
  app: {
    version: '',
    hash: ''
  },
  user: {
    type: '',
    dependency: {
      responsable: '',
      dependencia: '',
      id_Dependencia: ''
    },
    data: {}
  },
  alert:{
    color: 'success',
    show: false,
    message: ''
  },
  mInterval: {}
}

const store = new Vuex.Store({
  state,
  mutations,
  actions,
  getters,
  plugins: [createPersistedState()],
})

if (module.hot) {
  module.hot.accept([
    './store/getters',
    './store/actions',
    './store/mutations'
  ], () => {
    store.hotUpdate({
      getters: require('./store/getters'),
      actions: require('./store/actions'),
      mutations: require('./store/mutations')
    })
  })
}

export default store